import get from "lodash/get";
import { moment } from "@LIBS";

const checkType = (val) => {
  if (val === undefined || val === null) {
    return {
      type: "string",
      valueStr: "",
    };
  }
  if (moment(val, true).isValid()) {
    return {
      type: "date",
      valueStr: moment(val),
    };
  } else if (typeof val === "number") {
    return {
      type: "number",
      valueStr: val,
    };
  } else if (typeof val === "string") {
    return {
      type: "string",
      valueStr: val.toLocaleLowerCase("tr"),
    };
  } else {
    console.error("addSearchValue type hatası.");
    return {
      type: "string",
      valueStr: "",
    };
  }
};

const addSearchValue = (arr, row) => {
  const searchValues = arr.map((item) => {
    const labelStr = item.title.toLocaleLowerCase("tr");
    if (typeof item.key === "string") {
      let val = get(row, item.key);
      // hack for [last] item
      if (item.key.includes("last")) {
        const name = item.key.split("[last]")[0];
        const size = get(row, name).length;
        const newItem = item.key.replace("last", size - 1);
        val = get(row, newItem);
      }
      const types = checkType(val);
      return {
        label: item.title,
        value: val || "",
        labelStr,
        ...types,
        searchStr: `${labelStr}: ${types.valueStr}`,
      };
    } else if (typeof item.key === "object") {
      if (item.key.length > 1) {
        let val = item.key.map((val) => get(row, val)).join(" ");
        // hack for [last] item
        if (item.key[0].includes("last")) {
          const name = item.key[0].split("[last]")[0];
          const size = get(row, name).length;
          const newItem = item.key[0].replace("last", size - 1);
          val = get(row, newItem);
        }
        const types = checkType(val);
        return {
          label: item.title,
          value: val || "",
          labelStr,
          ...types,
          searchStr: `${labelStr}: ${types.valueStr}`,
        };
      } else {
        // string yapmasın diye.
        let val = get(row, item.key[0]);
        // hack for [last] item
        if (item.key[0].includes("last")) {
          const name = item.key[0].split("[last]")[0];
          const size = get(row, name).length;
          const newItem = item.key[0].replace("last", size - 1);
          val = get(row, newItem);
        }
        let types = {};
        if (val) {
          types = checkType(val);
        }
        return {
          label: item.title,
          value: val || "",
          labelStr,
          ...types,
          searchStr: `${labelStr}: ${types?.valueStr}`,
        };
      }
    }
    return {};
  });

  return searchValues;
};

export default addSearchValue;
